export const order_Loading_status = 'order_Loading_status';

export const order_Get_Success_status = 'order_Get_Success_status';

export const order_Error_status = 'order_Error_status';

export const order_Add_Success_status = 'order_Add_Success_status';

export const order_Delete_Success_status = 'order_Delete_Success_status';

export const order_Update_Success_status = 'order_Update_Success_status';

